import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--spacing-small);
  min-height: 80px;
  padding: var(--spacing-base) 0;
`;

export const ResultsFor = styled.h2`
  font-size: var(--font-size-display-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--black);
  margin: 0;
`;

export const SearchTerm = styled.span`
  color: var(--brand-800);
  font-weight: var(--font-weight-semibold);
`;

export const RefinementsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-small);
  flex-wrap: wrap;
  min-height: 34px;

  @media (width < 48rem) {
    justify-content: flex-start;
  }
`;

export const FilterTag = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-small);
  width: fit-content;
  padding: var(--spacing-small);
  background: var(--grey-100);
  border: none;
  border-radius: var(--radius-base);
  font-size: var(--font-size-text-sm);
  color: var(--black);
  cursor: pointer;

  & svg {
    width: 14px;
    height: 14px;

    & path {
      stroke: var(--grey-600);
    }
  }

  &:hover {
    background: var(--grey-100);
  }
`;

export const ClearAllButton = styled.button`
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  padding: var(--spacing-small);
  background: none;
  border: none;
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--brand-900);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
